<template>
  <div class="bindpublicAccount">
    <div class="bindpublicAccount_content">
      <div class="item">
        <span class="title">红包编号</span>
        <span class="text">{{ parameter.red_packet_no }}</span>
      </div>
      <div class="item">
        <span class="title w-t">公众号appid</span>
        <div class="inner-tag">
          <el-tag style="margin:0px 10px 10px 0px" type="warning" @click="chooseaccout">选择公众号</el-tag>
          <el-tag
            v-for="itemr,index in parameter.app_ids"
            :key="index"
            style="margin-right:10px;margin-bottom:5px;"
            closable
            :type="itemr.type"
            @close="rightclick(itemr.id,index)"
          >
            {{ itemr.name }}
          </el-tag>

        </div>
      </div>
    </div>
    <div style="text-align: end; margin-top: 20px;">
      <el-button type="primary" @click="$emit('determine', parameter)">确定</el-button>
    </div>

    <el-dialog
      :visible.sync="dialogVisibler"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" @closedialogone="closedialogone" />
    </el-dialog>
  </div>
</template>

<script>
import ChooseaccountDialog from '@/views/wechatbinding/components/ChooseaccountDialog.vue'
export default {
  components: {
    ChooseaccountDialog
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    red_packet_no: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      parameter: {
        red_packet_no: this.red_packet_no,
        app_ids: []
      },
      dialogVisibler: false
    }
  },
  methods: {
    chooseaccout() {
      this.dialogVisibler = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.sendrs(this.parameter.app_ids)
      }, 100)
    },
    rightclick(id, index) {
      this.parameter.app_ids.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)

      console.log(id, index)
    },

    closedialog(arr) {
      this.app_ids = arr
      this.dialogVisibler = false
    },
    closedialogone(arr) {
      this.app_ids = arr
    }
  }
}
</script>

<style scoped>
.bindpublicAccount{

}

.bindpublicAccount_content{

}

.item{
  margin-bottom: 15px;
  font-size: 17px;
  display: flex;
}

.title{
    display: inline-block;
    width: 150px;
}

.inner-tag{
    width:80%;
    height:20vw;
    overflow-y:scroll;
  }

@media (max-width: 768px){
  .title{
    font-size:3.5vw;
    width:100px;
  }
  .item{
    font-size:3vw;
  }
  .el-tag--medium{
    height:26px !important;
  }
  .inner-tag{
    height:50vw;
  }
}
</style>
